import { render, staticRenderFns } from "./document-compare-page.vue?vue&type=template&id=92516ca4&scoped=true&"
import script from "./document-compare-page.vue?vue&type=script&lang=js&"
export * from "./document-compare-page.vue?vue&type=script&lang=js&"
import style0 from "./document-compare-page.vue?vue&type=style&index=0&id=92516ca4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92516ca4",
  null
  
)

export default component.exports